export default __webpack_public_path__ + "assets/horizontal-dots.b767b312.png";